import { wrapPageElement as wrap } from "./src/woot-wapper"

export const wrapPageElement = wrap
